import { privateRequest } from "../axios";

const ENDPOINTS = {
  customerStage: "api/CRM/LeadStage",
  customerSource: "api/CRM/LeadSource",
  visitPurpose: "api/CRM/VisitPurposes",
  crmSetting: "api/CRM/CRMSetting",
  saleTargetFields: "api/SaleTargetFields",
  salesUnits: "api/Units",
  crmLead: "api/CRM/LeadType",
  customerAuditTeamMembers: "api/CRM/Audit/TeamMembers",
  setCustomerAuditTeamMembers: "api/CRM/Audit/TeamMembers",
  roleCustomerViewLimits: "api/CRM/Audit/Roles",
  setRoleCustomerViewLimits: "api/CRM/Audit/Roles",
};

const contentTypeConfig = {
  headers: {
    "Content-Type": "application/json",
  },
};

const fetchList = async (endpoint: string) => {
  const res = await privateRequest.get(endpoint);
  return res.data;
};

const deleteItem = async (endpoint: string, id: number) => {
  const res = await privateRequest.delete(ENDPOINTS.crmLead === endpoint ? `${endpoint}?Id=${id}` : `${endpoint}/${id}`);
  return res.data;
};

const addItem = async (endpoint: string, payload: any, stringify = false) => {
  const body = stringify ? JSON.stringify(payload) : payload;
  const res = await privateRequest.post(endpoint, body, contentTypeConfig);
  return res.data;
};

const fetchCrmSetting = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.crmSetting);
  return res.data;
};

const fetchSaleTargetFields = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.saleTargetFields);
  return res.data;
};

const fetchSalesTargetUnit = async (payload: any): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.salesUnits, {
    params: payload,
  });
  return res.data;
};

const updateCrmSetting = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.crmSetting, payload);
  return response.data;
};

const fetchCustomerAuditTeamMembers = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.customerAuditTeamMembers);
  return res.data;
};

const setCustomerAuditTeamMembers = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.setCustomerAuditTeamMembers, payload, contentTypeConfig);
  return response.data;
};

const fetchRoleCustomerViewLimits = async (): Promise<any> => {
  const res = await privateRequest.get(ENDPOINTS.roleCustomerViewLimits);
  return res.data;
};

const setRoleCustomerViewLimits = async (payload: any): Promise<any> => {
  const response = await privateRequest.post(ENDPOINTS.setRoleCustomerViewLimits, payload, contentTypeConfig );
  return response.data;
};

const CrmSettingService = {
  fetchList,
  deleteItem,
  addItem,
  fetchCrmSetting,
  fetchSaleTargetFields,
  fetchSalesTargetUnit,
  updateCrmSetting,
  fetchCustomerAuditTeamMembers,
  setCustomerAuditTeamMembers,
  fetchRoleCustomerViewLimits,
  setRoleCustomerViewLimits,
  ENDPOINTS,
};

export default CrmSettingService;
